import { Field } from './Field';
import { IMultiField } from './IMultiField';
import { ComparisonType } from './ComparisonType';
import { Tag } from '../../tagging/Tag';

export class MultiTagField extends Field implements IMultiField<Tag> {
  public values: Tag[];

  constructor(name: string, description: string, values: Tag[] = null, comparisonType: ComparisonType = null) {
    super(name, description, MultiTagField.typeName(), comparisonType);
    this.values = values;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.MultiTagField";
  }
}
